const editService = {
  pageTitle: 'Editar serviço',
  buttonReport: 'Relatórios',
  reportMenuItem: 'Gerar relatório (.pdf)',
  exportMenuItem: 'Exportar dados (.xls)',
  serviceDetailsTitle: 'Detalhes do serviço',
  serviceDate: 'Data do serviço',
  serviceAccountable: 'Criado por:',
  doneInDelay: 'Concluído em atraso:',
  endOfMonthExpiration: 'Expira ao fim do mês:',
  mandatoryActions: 'Ações são mandatórias:',
  localization: 'Localização',
  noCoordinates: 'Coordenadas não informadas',
  yes: 'Sim',
  no: 'Não',
  discard: 'Descartar',
  confirm: 'Confirmar',
  goToEquipment: 'Ir para os detalhes do equipamento',
  goToPlace: 'Ir para página do lugar',
  actionsMandatory: 'No momento do preenchimento do serviço, as ações eram mandatórias para perguntas com resposta "Não Atende"',
  actionsNumber: 'Ações abertas para esse serviço:',
  actionCompleted: 'finalizada',
  actionsCompleted: 'finalizadas',
  expiration: 'Vencimento:',
  daysRemaining: 'dias restantes',
  daysOverdue: 'dias em atraso',
  dayRemaining: 'dia restante',
  dayOverdue: 'dia em atraso',
  createdAt: 'Criado em:',
  downloadFiles: 'Baixar arquivos (.zip)',
  web: "Web",
  app: "App",
  legacy: "Legado",
  legacyApp: "Legado App",
  legacyWeb: "Legado Web",
  appQrcode: "App Qrcode",
  appCalendar: "App Calendário",
  appPlaces: "App Lugares",
  appAllEquipments: "App Lista de Equipamentos",
  appMap: "App Mapa",
  source: "Fonte:",
};

export default editService;